import React, { createContext, useReducer } from "react";
import { authenticationReducer } from "../reducers/authenticationReducer";
import { NPL_GUEST_AUTH, isNplDashboardHost } from "../config/nplGuestConfig";

export const AuthenticationContext = createContext();

const AuthenticationContextProvider = (props) => {
  // const [persist, setPersist] = useState(
  //   JSON.parse(localStorage).getItem("persist") || false
  // );
  const [auth, dispatch] = useReducer(
    authenticationReducer,
    isNplDashboardHost()
      ? NPL_GUEST_AUTH
      : {
          token: null,
          roles: null,
          presistLogin: false,
        }
  );
  return (
    <AuthenticationContext.Provider
      value={{ auth, dispatch /*persist, setPersist*/ }}
    >
      {props.children}
    </AuthenticationContext.Provider>
  );
};

export default AuthenticationContextProvider;
